import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.min.css'

import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {ChartDataProvider} from "hooks/use-chart-data";
import {LanguageProvider} from "hooks/use-language";

ReactDOM.render(
    <React.StrictMode>
        <LanguageProvider>
            <ChartDataProvider>
                <App/>
            </ChartDataProvider>
        </LanguageProvider>
    </React.StrictMode>,
    document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
